import { render, staticRenderFns } from "./Moneris.vue?vue&type=template&id=b1f8b922&scoped=true"
import script from "./Moneris.vue?vue&type=script&lang=js"
export * from "./Moneris.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1f8b922",
  null
  
)

export default component.exports